import { styled as zds } from '@zoopla-eng/zds-components/themes';

export const StyledImage = zds('img', {
    display: 'block',
    width: '100%'
});
